import { useRouter } from 'next/router'
import { FAQSubHeader, MoreQuestions } from '@/src/components/FAQ/FAQUtils'
import { Box } from '@mui/material'
import { Typography } from '@evocolabs/orkaui'
import Link from 'next/link'
import ChevronRightSmall24 from '@evocolabs/icons/lib/ChevronRightSmall24'

import styles from '@/pages/scss/FAQ.module.scss'

const SectionItem = ({ title, qstId }) => {
  return (
    <Link href={`/FAQ/qst/${qstId}`}>
      <Box key={qstId} className={styles.faqSessionWrapper}>
        <Box className={styles.faqSessionWrapperInner}>
          <Typography variant="Body1">{title}</Typography>
          <ChevronRightSmall24 />
        </Box>
        <hr />
      </Box>
    </Link>
  )
}

const FAQSection = ({ data }) => {
  const router = useRouter()
  const { section_name } = router.query
  return (
    <Box>
      <FAQSubHeader backUrl="/FAQ" title={section_name} />
      <Box px={2}>
        {data.results.data
          .filter((d) => d.section === section_name)
          .sort((a, b) => b.frequency - a.frequency)
          .map((d) => {
            return <SectionItem title={d.question} qstId={d.id} />
          })}
        <MoreQuestions section_name={section_name} />
        <Box mb="145px" />
      </Box>
    </Box>
  )
}

export async function getStaticPaths() {
  const url = process.env.NEXT_PUBLIC_BASEURL + 'faq/'
  const res = await fetch(url)
  const data = await res.json()
  return {
    paths: [...new Set(data.results.data.map((d) => d.section))].map(
      (section) => {
        return {
          params: {
            section_name: section
          }
        }
      }
    ),
    fallback: false
  }
}

export async function getStaticProps() {
  const url = process.env.NEXT_PUBLIC_BASEURL + 'faq/'
  const res = await fetch(url)
  const data = await res.json()
  return { props: { data }, revalidate: 600 }
}

export default FAQSection
